export const enum UIEvents {
	builtInFormValidateSucess = "builtInFormValidateSucess",
}
